import { useEffect } from 'react';

import HeaderExtra from '../components/HeaderExtra'
import Footer from '../components/Footer.jsx';

import '../Assets/css/paymentform.css'
import '../Assets/css/referralmenu.css'
import '../Assets/css/vouchermenu.css'
import '../Assets/css/voucherdetails.css'

import  '../Assets/js/datetimefunc.js'
// import  '../Assets/js/messagelang.js'
import  '../Assets/js/voucherdetails.js'

function VoucherDetails()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("VoucherDetails");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderExtra />
        
        <div className="MainContentSection" id="AllMainContentSection">
          <div className="MainSectionBasicWithBlue" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
            <div className="VoucherDetailsContentWrapper" id="VoucherAllMainSectionContainer">
              <div className="VoucherDetailsLeftWrapper">
                <div className="InputFieldMargin3" id="VoucherDescHeadContainer">
                  <p className="SectionHeaderTextIndex2 InterBoldTextFont" id="VoucherDescHeaderText">Deskripsi Voucher</p>
                </div>
                <div className="InputFieldMargin2" id="VoucherDescriptionTextContainer" style={{display:"none"}}>
                  <p className="DescriptionTextNotDisableable InterRegularTextFont" id="VoucherDescriptionText">In addition to the standard of Indonesia Care, all guests get free Wi-Fi in all rooms and free parking if arriving by car. Conveniently situated in the Uluwatu part of Bali. Lorem ip</p>
                </div>
                <div className="InputFieldMargin2" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}} id="VoucherDescriptionLoadingContainer">
                  <div className="RoomHotelRightInfo2 loading_grey" style={{width:"100%"}} />
                  <div className="RoomHotelRightInfo2 loading_grey " style={{"margin":"0",width:"90%"}} />
                </div>
                <div className="InputFieldMargin3 SyaratKetentuanSection">
                  <p className="SectionHeaderTextIndex2 InterBoldTextFont" id="SyaratKetentuanHeaderText">Syarat &amp; Ketentuan</p>
                </div>
                <div className="InputFieldMargin2 SyaratKetentuanSection">
                  <ul className="BasicListContainer NumberCounterUL InterRegularTextFont" style={{width:"100%"}} id="SyaratKetentuanListContainer">
                    <li className="loading_grey" style={{"color":"transparent",width:"100%"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Test Description Loading</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"80%"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Test Description Loading</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"90%"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Test Description Loading</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"100%"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Test Description Loading</p>
                      </div>
                    </li>
                  </ul>
                </div>


                <div className="InputFieldMargin3">
                  <p className="SectionHeaderTextIndex2 InterBoldTextFont" id="CaraPakaiHeaderText">Cara Pakai</p>
                </div>
                <div className="InputFieldMargin2">
                  <ul className="BasicListContainer NumberCounterUL InterRegularTextFont" id="CaraPakaiTextContainer">
                    <li className="loading_grey" style={{"color":"transparent",width:"fit-content"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Masuk ke halaman Voucher Saya dan pilih voucher.</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"fit-content"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Salin kode voucher yang kamu pilih</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"fit-content"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Cari tanggal dan akomodasi yang kamu inginkan</p>
                      </div>
                    </li>
                    <li className="loading_grey" style={{"color":"transparent",width:"fit-content"}}>
                      <div className="BasicListContentWrapper">
                        <p className="DescriptionTextNotDisableable InterMediumTextFont">Masukkan kode voucher di detail transaksi lalu apply voucher</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="VoucherDetailsRightWrapper">
                <div className="VoucherDetailsMainPanel BasicBoxShadow BasicRoundRadius">
                  <div className="TopRewardSection">
                    <div className="FlagBackVoucher" id="FlagVoucherMain" style={{display:"none"}}>
                      <img src="/Assets/images/ButtonIcon/RefDetailsBackFlag.png" className="FlagBackVoucherIMG" />
                      <div className="FlagMainVoucher">
                        <p className="DescriptionTextNotDisableable InterBoldTextFont" id="FlagVoucherTypeText">Partner PinginGo</p>
                      </div>
                    </div>
                    <div className="VoucherImageContainer BasicRoundRadius loading_grey BasicBoxShadowMid" id="VoucherImageContainer"></div>
                    <div className="VoucherInfoWrapper">
                      <div className="BasicChildMargin2 InputFieldMargin3" style={{display:"flex"}} id="VoucherNameWrapper">
                        <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont loading_grey2" style={{"color":"transparent"}} id="VoucherNameText">Discount Referral 100rb</p>
                      </div>
                      <div className="RewardInfoSeparatorWrapper" id="VoucherInfoContainerWrapper">
                        <div className="PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4">
                          <div className="RewardInfoSmallWrapper">
                            <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{"color":"transparent",width:"fit-content"}}>Tanggal Claim</p>
                            <p className="SmallerRoomDescriptionText InterRegularTextFont loading_grey" style={{marginLeft:"auto","color":"transparent",width:"fit-content"}}>-- --- ----, 00.00</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="VoucherDetailsInfoWrapper">
                    <div className="BasicRoundRadius KodeVoucherDetailsWrapper InputFieldMargin3 loading_grey2" id="VoucherCodeContainer">
                      <p className="SmallerRoomDescriptionText InterMediumTextFont" style={{"color":"#797979","opacity":"0"}} id="KodeVoucherHeaderText">Kode Voucher</p>
                      <p className="LabelGreyHeaderBiggerText InterRegularTextFont CopyText" style={{"color":"rgb(29, 41, 57)","opacity":"0"}} id="KodeVoucherKodeText">TEST12345</p>
                    </div>
                    <button className="BasicTextButton OrangeButton SignInButtonTop Selectable loading_grey" style={{"margin":"0",width:"100%"}} id="VoucherDetailsOrangeBtn">
                      <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto","opacity":"0"}} id="VoucherDetailsOrangeBtnContentWrapper">
                        <img src="/Assets/images/ButtonIcon/copy-white-icon2.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} id="VoucherDetailsOrangeBtnIcon" />
                        <p id="VoucherDetailsOrangeBtnText">Salin Kode Voucher</p>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="VoucherDetailsContentWrapper" id="NoVoucherFoundContainer" style={{display:"none"}}>
              <div className="NoFeaturedPropertyFoundContainer NotFoundWrapper">
                <img src="/Assets/images/Icon/NoVoucherFound.svg" className="NoFoundIcon InputFieldMargin3" />
                <p className="NoFoundHeaderText InterBoldTextFont" id="NoVoucherFoundHeaderText">Oops, Voucher Not Found</p>
                <p className="NoFoundMessageText InterRegularTextFont" style={{width:"85%"}} id="NoVoucherFoundMessageText">The Voucher that you are attempting to load is not valid.</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Footer/>
    </>
  )
}

export default VoucherDetails